/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Done_PausedInputs */

const en_cancel_done_paused = /** @type {(inputs: Cancel_Done_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription has been paused.`)
};

const de_cancel_done_paused = /** @type {(inputs: Cancel_Done_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Abo wurde pausiert.`)
};

const fr_cancel_done_paused = /** @type {(inputs: Cancel_Done_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton abonnement a ete mis en pause.`)
};

const es_cancel_done_paused = /** @type {(inputs: Cancel_Done_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu suscripcion ha sido pausada.`)
};

const it_cancel_done_paused = /** @type {(inputs: Cancel_Done_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo abbonamento e stato messo in pausa.`)
};

const nl_cancel_done_paused = /** @type {(inputs: Cancel_Done_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je abonnement is gepauzeerd.`)
};

const pl_cancel_done_paused = /** @type {(inputs: Cancel_Done_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoja subskrypcja zostala wstrzymana.`)
};

const fi_cancel_done_paused = /** @type {(inputs: Cancel_Done_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilauksesi on tauotettu.`)
};

const da_cancel_done_paused = /** @type {(inputs: Cancel_Done_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit abonnement er sat på pause.`)
};

const sv_cancel_done_paused = /** @type {(inputs: Cancel_Done_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din prenumeration har pausats.`)
};

/**
* | output |
* | --- |
* | "Your subscription has been paused." |
*
* @param {Cancel_Done_PausedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_done_paused = /** @type {((inputs?: Cancel_Done_PausedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Done_PausedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_done_paused(inputs)
	if (locale === "fr") return fr_cancel_done_paused(inputs)
	if (locale === "es") return es_cancel_done_paused(inputs)
	if (locale === "it") return it_cancel_done_paused(inputs)
	if (locale === "nl") return nl_cancel_done_paused(inputs)
	if (locale === "pl") return pl_cancel_done_paused(inputs)
	if (locale === "fi") return fi_cancel_done_paused(inputs)
	if (locale === "da") return da_cancel_done_paused(inputs)
	if (locale === "sv") return sv_cancel_done_paused(inputs)
	return en_cancel_done_paused(inputs)
});